<template>
  <div class="officeReEdit" ref="officeReEdit">

    <div :style="{height:canvasHeight+ 'px'}" class='officeContent' id="officeContent">

      <div class="office_pdf">
        <zl_pdf src="https://cjddcloudtest.cailian.net/cjdd/resourse/20211210/680D783F1639129253882.pdf"></zl_pdf>
      </div>

      <div v-if="isEdit" :style="{
      width:canvasWidth+'px',
      height:canvasHeight+'px',
       }">
        <canvas id='officeCanvas' :width="canvasWidth" :height="canvasHeight"></canvas>
      </div>
    </div>

    <div class="officeTools">
      <!-- <span @click="switchingFunction"> 展示/编辑 </span> -->
      <i v-show="isEdit" class='el-icon-arrow-up' @click="switchingFunction" style="font-size:25px;"></i>
      <i v-show="!isEdit" class='el-icon-arrow-down' @click="switchingFunction" style="font-size:25px;"></i>
      <div v-show="isEdit" class="fillColor">
        <el-color-picker @change="selectColor" v-model="drawColor" :predefine="predefineColors"></el-color-picker>
        <el-slider style="width: 100px;position:relative;left:45px;top:5px;" v-model="drawWidth" @change="setDrawWidth"></el-slider>
        <div class='lines'>
             <div
                  style="margin-top: 10px;cursor: pointer;margin-left: 25px;"
                  v-for="(item,idx) in toolsArr" :key="idx"
                  @click="handleTools(item)">
                  <el-tooltip :content="item.label" placement="bottom" effect="light">
                      <i :class="item.type"></i>
                  </el-tooltip>
              </div>
              <el-tooltip content="生成图片" placement="bottom" effect="light">
                    <i class="iconfont icon-tupian" @click="onLoadImage()" style="position:relative;top: 10px;left:25px;"></i>
              </el-tooltip>
              <!-- <i class="iconfont icon-tupian" @click="onLoadImage()" style="position:relative;top: 10px;left:25px;"></i> -->
              <!-- <span @click="onLoadImage()" style="position:relative;top: 10px;left:25px;">生成图片</span> -->
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import html2canvas from "html2canvas";
  import {fabric} from 'fabric';
  import zl_pdf from "./zl_pdf";
  import './js/eraserBrush'

  /**
   *   文件的再编辑组件
   *     预览PPT, 在图层上图画书写并保留编辑页面
   *     create by wjl at 2022.4.7
   */
  export default {
    name: "officeReEdit",
    props: {},
    data() {
      return {
        isEdit: false,
        canvasWidth: '',
        canvasHeight: '',
        myCanvas: null,
        drawWidth: 10,   // 笔条粗细
        drawColor: '#000000',    // 功能切换
        predefineColors: ['#000000', '#0000FF', '#FF0000', '#00FF00', '#FFFF00', '#00FFFF', '#FF00FF',],
        //
        currentTool: '',
        toolsArr: [
          {name: 'select', label: '选中',type:'el-icon-thumb'},
          {name: 'pencil', label: '画笔',type:'el-icon-edit'},
          // {name: 'erase', label: '橡皮擦'},
          {name: 'line', label: '直线',type:'iconfont icon-zhixian'},
          {name: 'arrow', label: '箭头',type:'iconfont icon-jiantou_youxia'},
          {name: 'xuxian', label: '虚线',type:'iconfont icon-xuxian'},
          {name: 'text', label: '文本',type:'iconfont icon-wenben'},
          {name: 'juxing', label: '矩形',type:'iconfont icon-juxing'},
          {name: 'cricle', label: '圆',type:'iconfont icon-xingzhuang-tuoyuanxing'},
          // {name: 'ellipse', label: '椭圆'},
          // {name: 'equilateral', label: '三角形'},
          // {name: 'remove', label: '删除'},
          {name: 'undo', label: '上一步',type:'el-icon-back'},
          {name: 'redo', label: '下一步',type:'el-icon-right'},
          {name: 'reset', label: '清空',type:'el-icon-delete'},
          {name: 'eraser', label: '橡皮擦',type:'iconfont icon-xiangpica'},
        ],
        mouseFrom: {},
        mouseTo: {},
        moveCount: 1,
        doDrawing: false,
        fabricHistoryJson: [],
        mods: 0,
        drawingObject: null, //绘制对象
        //
        progress: 1,//资源进度
        pageNum: 1,//pdf上一页
        pageTotalNum: 1,//pdf下一页
      }
    },
    components: {zl_pdf},
    created() {
    },
    mounted() {
      this.canvasWidth = this.$refs.officeReEdit.offsetWidth;
      this.canvasHeight = this.$refs.officeReEdit.offsetHeight;
    },
    watch: {
      isEdit(val) {
        if (val) {
          this.$nextTick(() => {
            this.init();
          })
          let that = this;
          document.onkeydown = function () {
            var oEvent = window.event;
            if (oEvent.keyCode == 46) { // 选中删除
              if (that.myCanvas.getActiveObject()) {
                that.myCanvas.remove(that.myCanvas.getActiveObject())
              }
            }
            if (oEvent.ctrlKey && oEvent.which == 90) { //撤回
              that.undo()
            }
          }
        }
      }
    },
    methods: {
      init() {
        this.myCanvas = new fabric.Canvas('officeCanvas', {
          isDrawingMode: false,
          selectable: true,
          selection: true,
          devicePixelRatio: true, //Retina 高清屏 屏幕支持
        });
        this.handleTools({
          name: 'pencil'
        });
        //绑定画板事件
        this.myCanvasAddEvent()
      },

      handleTools(tools) {
        this.currentTool = tools.name;
        this.resetObj()
        switch (tools.name) {
          case "select":
            this.myCanvas.isDrawingMode = false;
            this.myCanvas.selectable = true;
            this.myCanvas.selection = true;
            this.myCanvas.skipTargetFind = false;
            break;
          case 'pencil':
            this.myCanvas.freeDrawingBrush = new fabric.PencilBrush(this.myCanvas);
            this.myCanvas.isDrawingMode = true;
            break;
          case 'erase':
            // this.myCanvas.freeDrawingBrush = new fabric.EraserBrush(this.myCanvas);
            // this.myCanvas.isDrawingMode = true;
            break;

          // case 'remove':
          //   this.myCanvas.selection = true
          //   this.myCanvas.skipTargetFind = false
          //   this.myCanvas.selectable = true
          //   break;
          case 'reset':
            this.myCanvas.remove(this.myCanvas.getActiveObject());
            this.myCanvas.clear();
            this.myCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
            this.handleTools({
              name: 'pencil'
            });
            break;
          case 'eraser':
            this.myCanvas.freeDrawingBrush = new fabric.EraserBrush(this.myCanvas);
            this.myCanvas.freeDrawingBrush.width = 10;
            this.myCanvas.isDrawingMode = true;
            break;
          case 'redo':
            this.redo();
            break;
          case 'undo':
            this.undo();
            break;
          default:
            break;
        }
      },

      onLoadImage() {
        let shareContent = document.getElementById('officeContent'),//需要截图的包裹的（原生的）DOM 对象
          width = shareContent.clientWidth,//shareContent.offsetWidth; //获取dom 宽度
          height = shareContent.clientHeight,//shareContent.offsetHeight; //获取dom 高度
          canvas = document.createElement("canvas"), //创建一个canvas节点
          scale = 1; //定义任意放大倍数 支持小数
        canvas.width = width * scale; //定义canvas 宽度 * 缩放
        canvas.height = height * scale; //定义canvas高度 *缩放
        canvas.style.width = shareContent.clientWidth * scale + "px";
        canvas.style.height = shareContent.clientHeight * scale + "px";
        canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
        let opts = {
          scale: scale, // 添加的scale 参数
          canvas: canvas, //自定义 canvas
          logging: false, //日志开关，便于查看html2canvas的内部执行流程
          width: width, //dom 原始宽度
          height: height,
          useCORS: true // 【重要】开启跨域配置
        };
        html2canvas(shareContent, opts).then(function (canvas) {
          let imgUrl = canvas.toDataURL("image/png");
          const img = new Image();
          img.src = imgUrl;
          const newWin = window.open("", "_blank");
          newWin.document.write(img.outerHTML);
          newWin.document.close();
        });
      },

      setDrawWidth(num) {
        this.drawWidth = num;
        this.myCanvas.freeDrawingBrush.width = this.drawWidth;
      },
      selectColor(color) {
        this.myCanvas.freeDrawingBrush.color = color;
      },
      switchingFunction() {
        this.isEdit = !this.isEdit

      },

      //时间监听
      myCanvasAddEvent() {
        this.myCanvas.on({
          'mouse:down': (o) => {
            this.mouseFrom.x = o.pointer.x;
            this.mouseFrom.y = o.pointer.y;
            this.doDrawing = true;
            if (this.currentTool == 'text') {
              this.drawText()
            }
          },
          'mouse:up': (o) => {
            this.mouseTo.x = o.pointer.x;
            this.mouseTo.y = o.pointer.y;
            this.drawingObject = null;
            this.moveCount = 1;
            this.doDrawing = false;
            this.updateModifications(true);
          },
          'mouse:move': (o) => {
            if (this.moveCount % 2 && !this.doDrawing) {
              //减少绘制频率
              return;
            }
            this.moveCount++;
            this.mouseTo.x = o.pointer.x;
            this.mouseTo.y = o.pointer.y;
            this.drawing();
          },
          //对象移动时间
          'object:moving': (e) => {
            e.target.opacity = 0.5;
          },
          //增加对象
          'object:added': (e) => {
            // debugger
          },
          'object:modified': (e) => {
            e.target.opacity = 1;
            // let object = e.target;
            this.updateModifications(true)
          },
          // 'selection:created': (e)=>{
          //   if (e.target._objects) {
          //     //多选删除
          //     var etCount = e.target._objects.length;
          //     for (var etindex = 0; etindex < etCount; etindex++) {
          //       this.myCanvas.remove(e.target._objects[etindex]);
          //     }
          //   } else {
          //     //单选删除
          //     this.myCanvas.remove(e.target);
          //   }
          //   this.myCanvas.discardActiveObject(); //清楚选中框
          //   this.updateModifications(true)
          // },
        });
      },
      //储存历史记录
      updateModifications(savehistory) {
        if (savehistory == true) {
          this.fabricHistoryJson.push(JSON.stringify(this.myCanvas))
        }
      },
      //canvas 历史后退
      undo() {
        let state = this.fabricHistoryJson
        if (this.mods < state.length) {
          this.myCanvas.clear().renderAll();
          this.myCanvas.loadFromJSON(state[state.length - 1 - this.mods - 1]);
          this.myCanvas.renderAll();
          this.mods += 1;
        }
      },
      //前进
      redo() {
        let state = this.fabricHistoryJson
        if (this.mods > 0) {
          this.myCanvas.clear().renderAll();
          this.myCanvas.loadFromJSON(state[state.length - 1 - this.mods + 1]);
          this.myCanvas.renderAll();
          this.mods -= 1;
        }
      },
      // 重置状态
      resetObj() {
        this.myCanvas.isDrawingMode = false;
        this.myCanvas.freeDrawingBrush.color = this.drawColor;
        this.myCanvas.selectable = false
        this.myCanvas.selection = false
        this.myCanvas.skipTargetFind = true
        //清除文字对象
        if (this.textboxObj) {
          this.textboxObj.exitEditing();
          this.textboxObj = null;
        }
      },
      //绘制文字对象
      drawText() {
        this.textboxObj = new fabric.Textbox(" ", {
          left: this.mouseFrom.x,
          top: this.mouseFrom.y,
          width: 220,
          fontSize: this.drawWidth,
          fill: this.drawColor,
          hasControls: true
        });
        this.myCanvas.add(this.textboxObj);
        this.textboxObj.enterEditing();
        this.textboxObj.hiddenTextarea.focus();
        this.updateModifications(true)
      },

      drawing() {
        if (this.drawingObject) {
          this.myCanvas.remove(this.drawingObject)
        }
        let myCanvasect = null
        switch (this.currentTool) {
          case 'pencil':
            this.myCanvas.isDrawingMode = true
            break;
          case 'line':
            myCanvasect = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
              stroke: this.drawColor,
              strokeWidth: this.drawWidth
            })
            break;
          case 'arrow':
            myCanvasect = new fabric.Path(this.drawArrow(this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y, 17.5, 17.5), {
              stroke: this.drawColor,
              fill: "rgba(255,255,255,0)",
              strokeWidth: this.drawWidth
            });
            break;
          case 'xuxian': //doshed line
            myCanvasect = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
              strokeDashArray: [10, 3],
              stroke: this.drawColor,
              strokeWidth: this.drawWidth
            })
            break;
          case 'juxing': //矩形
            let path = "M " +
              this.mouseFrom.x + " " +
              this.mouseFrom.y + " L " +
              this.mouseTo.x + " " +
              this.mouseFrom.y + " L " +
              this.mouseTo.x + " " +
              this.mouseTo.y + " L " +
              this.mouseFrom.x + " " +
              this.mouseTo.y + " L " +
              this.mouseFrom.x + " " +
              this.mouseFrom.y + " z";
            myCanvasect = new fabric.Path(path, {
              left: this.mouseFrom.x,
              top: this.mouseFrom.y,
              stroke: this.drawColor,
              strokeWidth: this.drawWidth,
              fill: "rgba(255, 255, 255, 0)"
            });
            break;
          case "cricle": //正圆
            let radius = Math.sqrt((this.mouseTo.x - this.mouseFrom.x) * (this.mouseTo.x - this.mouseFrom.x) + (this.mouseTo.y - this.mouseFrom.y) * (this.mouseTo.y - this.mouseFrom.y)) / 2;
            myCanvasect = new fabric.Circle({
              left: this.mouseFrom.x,
              top: this.mouseFrom.y,
              stroke: this.drawColor,
              fill: "rgba(255, 255, 255, 0)",
              radius: radius,
              strokeWidth: this.drawWidth
            });
            break;
          case "ellipse": //椭圆
            let left = this.mouseFrom.x;
            let top = this.mouseFrom.y;
            let ellipse = Math.sqrt((this.mouseTo.x - left) * (this.mouseTo.x - left) + (this.mouseTo.y - top) * (this.mouseTo.y - top)) / 2;
            myCanvasect = new fabric.Ellipse({
              left: left,
              top: top,
              stroke: this.drawColor,
              fill: "rgba(255, 255, 255, 0)",
              originX: "center",
              originY: "center",
              rx: Math.abs(left - this.mouseTo.x),
              ry: Math.abs(top - this.mouseTo.y),
              strokeWidth: this.drawWidth
            });
            break;
          case "equilateral": //等边三角形
            let height = this.mouseTo.y - this.mouseFrom.y;
            myCanvasect = new fabric.Triangle({
              top: this.mouseFrom.y,
              left: this.mouseFrom.x,
              width: Math.sqrt(Math.pow(height, 2) + Math.pow(height / 2.0, 2)),
              height: height,
              stroke: this.drawColor,
              strokeWidth: this.drawWidth,
              fill: "rgba(255,255,255,0)"
            });
            break;
          case 'remove':
            break;
          default:
            // statements_def'
            break;
        }
        if (myCanvasect) {
          this.myCanvas.add(myCanvasect)
          this.drawingObject = myCanvasect;
        }
      },
      //书写箭头的方法
      drawArrow(fromX, fromY, toX, toY, theta, headlen) {
        theta = typeof theta != "undefined" ? theta : 30;
        headlen = typeof theta != "undefined" ? headlen : 10;
        // 计算各角度和对应的P2,P3坐标
        let angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
          angle1 = (angle + theta) * Math.PI / 180,
          angle2 = (angle - theta) * Math.PI / 180,
          topX = headlen * Math.cos(angle1),
          topY = headlen * Math.sin(angle1),
          botX = headlen * Math.cos(angle2),
          botY = headlen * Math.sin(angle2);
        let arrowX = fromX - topX,
          arrowY = fromY - topY;
        let path = " M " + fromX + " " + fromY;
        path += " L " + toX + " " + toY;
        arrowX = toX + topX;
        arrowY = toY + topY;
        path += " M " + arrowX + " " + arrowY;
        path += " L " + toX + " " + toY;
        arrowX = toX + botX;
        arrowY = toY + botY;
        path += " L " + arrowX + " " + arrowY;
        return path;
      },
    }
  }
</script>

<style scoped lang="scss">
@import url('../../src/assets/fonts/text/iconfont.css');
  .officeReEdit {
    width: 100%;
    height: 100%;

    .officeContent {
      position: relative;

      .office_pdf {
        width: 100%;
        height: 100%;
        display: flex;
        overflow: auto;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;

        .btn-pre {
          position: absolute;
          left: 10px;
          top: 50%;
          padding: 5px 5px;
          margin: auto;
          font-size: 16px;
          width: 20px;
          height: 20px;
          background: rgba(0, 0, 0, 0.2);
          text-align: center;
          line-height: 20px;
          border-radius: 50%;
          cursor: pointer;

          &:hover {
            background: #5397F7;
            color: white;
          }
        }

        .btn-next {
          position: absolute;
          right: 50px;
          top: 50%;
          padding: 5px 5px;
          margin: auto;
          font-size: 16px;
          width: 20px;
          height: 20px;
          background: rgba(0, 0, 0, 0.2);
          text-align: center;
          line-height: 20px;
          border-radius: 50%;
          cursor: pointer;

          &:hover {
            background: #5397F7;
            color: white;
          }
        }

        .pdfCurrentPage {
          position: absolute;
          right: 50%;
          bottom: 15px;
        }
      }

      #myIframe {
        position: absolute;
        top: 0;
        left: 0;
        /*z-index: 1;*/
      }
    }

    .officeTools {
      width: 100%;
      // display: flex;
      position: absolute;
      bottom: 1px;
      text-align: center;
      // display: flex;
      // justify-content: center;
      // z-index: 4;
      // top: 60px;
      // right: 0;
      // transform: translateX(-50%);
      // align-items: center;
      // flex-direction: column;

      .toolsIcon {
        font-size: 20px;
      }

      span {
        margin-bottom: 15px;
        cursor: pointer;
      }

      .fillColor{
         display: flex;
         align-items: center;
         width: 700px;
         border:1px solid #ccc;
         box-shadow:10px 0px 10px 0px rgba(0,0,0,0.2);
         height: 60px;
         margin:0px auto 0px auto;
         padding-left: 25px;
         position: relative;
      }
    }
    .lines{
      display: flex;
      margin-left:31px;
    }
    /deep/ .el-color-picker__trigger{
       border:none !important;
       width: 25px !important;
       height: 25px !important;
       position: absolute;
    }
    /deep/ .el-color-picker__color-inner{
        display: inline-block;
        width: 25px !important;
        height: 25px !important;
        border:none !important;
        position: relative;
        top: 10px;
    }
    /deep/ .el-color-picker__color{
        border:none !important;
    }
    /deep/ .fillColor .el-color-picker__icon {
        position: absolute !important;
        top: 105% !important;
        left: 62% !important;
    }
    .onclone {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/officeReEdit.vue